import { render, staticRenderFns } from "./EB_Confirm.vue?vue&type=template&id=2ed06b86&scoped=true&"
import script from "./EB_Confirm.vue?vue&type=script&lang=js&"
export * from "./EB_Confirm.vue?vue&type=script&lang=js&"
import style0 from "./EB_Confirm.vue?vue&type=style&index=0&id=2ed06b86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed06b86",
  null
  
)

component.options.__file = "EB_Confirm.vue"
export default component.exports